import { toast } from "react-toastify";

// Use a unique key for the app's local storage session
const storageUserKey = "clubMangoUserSessionv1";

export const setUserKey = (value) => {
    if (value) {
        sessionStorage.setItem(storageUserKey, JSON.stringify(value));
    } else {
        sessionStorage.removeItem(storageUserKey);
    }
};

export const setToken = (token) => {
    const userKey = getUserKey();
    const sessionValue = userKey ? { ...userKey, token } : { token };
    setUserKey(sessionValue);
};

export const getUserKey = () => {
    const userStr = sessionStorage.getItem(storageUserKey);
    if (!userStr) return null;
    try {
        return JSON.parse(userStr);
    } catch (e) {
        return null;
    }
};

export const deleteUserKey = () => {
    sessionStorage.removeItem(storageUserKey);
};

export const postData = async ({ url, payload, highlightError, navigate, getFullResponse }) => {
    const userKey = getUserKey() || {};

    // Clone payload so we don't mutate the original object
    const finalPayload = { ...payload };

    if (userKey.token) {
        finalPayload.token = userKey.token;
    }

    if (userKey.id) {
        finalPayload.user_id = userKey.id;
    }

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(finalPayload),
        });

        const data = await response.json();

        if (
            data.status !== "success" &&
            (data.statusCode === "403" || data.statusCode === "401") &&
            navigate
        ) {
            deleteUserKey();
            navigate("/login");
            if (highlightError) {
                toast.error(data.msg || "Unauthorized access. Please log in.");
            }
            return null;
        } else if (data.status !== "success" && highlightError) {
            toast.error(data.msg || "An error occurred");
        }

        return getFullResponse ? data : data.response; // Default behavior returning `.response` similar to what was in ReactDemo7
    } catch (error) {
        console.error("Fetch error:", error);
        if (highlightError) {
            toast.error("Something went wrong");
        }
        return null;
    }
};
